<template>
  <v-row class="section-container lh--expedited-review-container">
    <v-col cols="12" class="header-with-select-box">
      <h3 class="text-primary weight-600">Expedited Review Request</h3>
    </v-col>

    <v-col cols="12">
      <v-checkbox
        id="expedited-review-24h"
        v-model="expeditedReviewWithin24h"
        :disabled="!props.isEditable"
        color="accent"
        hide-details
        label="CHECK THIS BOX IF YOU BELIEVE YOU NEED A DECISION WITHIN 24 HOURS (if you have a supporting statement from your prescriber, attach it to this request)."
        @change="emit('updateOrderInfoField', 'expeditedReviewWithin24h', expeditedReviewWithin24h)"></v-checkbox>
    </v-col>
    <v-col v-if="expeditedReviewWithin24h" cols="12">
      <p class="text-body-3-1 weight-600 text-primary mt-n4 mb-3">Must provide reason for expedited review:</p>
      <v-text-field
        v-model="expeditedReviewStatement"
        :readonly="!props.isEditable"
        :disabled="!props.isEditable"
        class="lh--force-white-background"
        density="compact"
        @change="emit('updateOrderInfoField', 'expeditedReviewStatement', expeditedReviewStatement)">
      </v-text-field>

      <p class="text-body-3-1 text-color-blue-gray weight-400 mt-2">
        NOTE: If you are asking for a formulary or tiering exception, your prescriber MUST provide a statement
        supporting your request. Requests that are subject to prior authorization (or any other utilization management
        requirement), may require supporting information. Your prescriber may use the attached "Supporting Information
        for an Exception Request or Prior Authorization" to support your request.
      </p>
    </v-col>
  </v-row>
</template>

<script setup>
import { ref } from "vue";

const emit = defineEmits(["updateOrderInfoField"]);

const props = defineProps({
  expeditedReviewWithin24h: {
    type: Boolean,
    default() {
      return false;
    },
  },
  expeditedReviewStatement: {
    type: String,
    default() {
      return "";
    },
  },
  isEditable: {
    type: Boolean,
    default() {
      return false;
    },
  },
});

const expeditedReviewWithin24h = ref(props.expeditedReviewWithin24h);
const expeditedReviewStatement = ref(props.expeditedReviewStatement);
</script>

<style lang="scss" scoped>
@import "../styles/pages/_patient-information-form.scss";
</style>
